import { Button, Menu, MenuItem } from '@mui/material';
import { readableProductType } from '../../util';
import { useRecoilValue } from 'recoil';
import { currentProductTypeState } from '../../states';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { TutorialButton } from './TutorialButton';
import useSynthOi from 'hooks/equityhub/useSynthOi';
import {
  PRODUCT_USER_GUIDES,
  PRODUCT_TRADING_MODULES,
} from '../../config/shared';
import { getAppcues, tutorialFlowIdForLocation } from '../../util';
import { ProductType } from 'types';

export const UsingProductButton = () => {
  const currentProductType = useRecoilValue(currentProductTypeState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [searchParams] = useSearchParams();
  const { isSynthOI } = useSynthOi();

  const tutorialFlowId = tutorialFlowIdForLocation(
    currentProductType,
    searchParams,
    isSynthOI,
  );
  const menuOpen = Boolean(anchorEl);

  const userGuideUrl =
    PRODUCT_USER_GUIDES.get(currentProductType as ProductType) ?? null;
  const tradingModuleUrl =
    PRODUCT_TRADING_MODULES.get(currentProductType as ProductType) ?? null;
  const hasTutorial = getAppcues() != null && tutorialFlowId != null;

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(null);
  };

  // If none of the three items are available, don't display the button
  if (userGuideUrl == null && !hasTutorial && tradingModuleUrl == null) {
    return null;
  }

  return (
    <>
      <Button
        variant="outlined"
        sx={{
          textTransform: 'none',
          fontSize: '10px',
          height: '30px',
          whiteSpace: 'nowrap',
          padding: '6px 12px',
          minWidth: 'fit-content',
        }}
        onClick={onClick}
      >
        Using {readableProductType(currentProductType)}
      </Button>
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={onClose}>
        {userGuideUrl != null && (
          <MenuItem
            onClick={() => {
              window.open(userGuideUrl, '_blank');
              onClose();
            }}
          >
            User Guide
          </MenuItem>
        )}
        {hasTutorial && (
          <MenuItem
            onClick={() => {
              getAppcues().show(tutorialFlowId);
              onClose();
            }}
          >
            <TutorialButton button={false} />
          </MenuItem>
        )}
        {tradingModuleUrl != null && (
          <MenuItem
            onClick={() => {
              window.open(tradingModuleUrl, '_blank');
              onClose();
            }}
          >
            Trading Module
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
